import PropTypes from 'prop-types';
import { useActiveCount } from '@medifind/hooks';
import { clearTrialFilters } from '@medifind/zustand';
import { ClinicalTrialResultFilterList } from '../filters/ClinicalTrialResultFilterList';
import SortingHeader from './SortingHeader';

const CTFiltersGroup = ({
  id,
  classes = {},
  totalResults,
  criteriaKeywords,
  sortItems,
  onSortByChange,
  sortValue,
  projectId,
  hideFilterButtonAt = 'md',
  showTrialCondition,
}) => {
  const activeFiltersCount = useActiveCount();

  return (
    <>
      <SortingHeader
        classes={classes}
        onSortByChange={onSortByChange}
        sortValue={sortValue}
        sortItems={sortItems}
        totalResults={totalResults}
        foundText={'clinical trials'}
        clearFilters={clearTrialFilters}
        hideFilterButtonAt={hideFilterButtonAt}
        filterList={<ClinicalTrialResultFilterList showTrialCondition={showTrialCondition} criteriaKeywords={criteriaKeywords} />}
        activeFiltersCount={activeFiltersCount}
      />
    </>
  );
};

CTFiltersGroup.propTypes = {
  classes: PropTypes.shape({
    filters: PropTypes.string,
    label: PropTypes.string,
    filter: PropTypes.string,
    filterWrapper: PropTypes.string,
  }),
  onPageChange: PropTypes.func,
  projectId: PropTypes.number,
  hideFilterButtonAt: PropTypes.string,
  showTrialCondition: PropTypes.bool,
  totalResults: PropTypes.number,
};

export { CTFiltersGroup as default, CTFiltersGroup };
